"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV2PaymentShoppingCart = void 0;
exports.v2PaymentShoppingCartSetMock = v2PaymentShoppingCartSetMock;
exports.v2PaymentShoppingCart = v2PaymentShoppingCart;
exports.useQueryV2PaymentShoppingCart = useQueryV2PaymentShoppingCart;
exports.useInfiniteQueryV2PaymentShoppingCart = useInfiniteQueryV2PaymentShoppingCart;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v2PaymentShoppingCartSetMock(mock) {
    setMock = mock;
}
async function v2PaymentShoppingCart(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v2/payment/shopping-cart`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.postalCode = params.postalCode;
    queryParams.promo = params.promo;
    queryParams.countryCode = params.countryCode;
    queryParams.currency = params.currency;
    queryParams.machineId = params.machineId;
    queryParams.state = params.state;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV2PaymentShoppingCart = 'cockatoo:v2PaymentShoppingCart:get';
function useQueryV2PaymentShoppingCart(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2PaymentShoppingCart, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV2PaymentShoppingCart(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2PaymentShoppingCart, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v2PaymentShoppingCart(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v2-payment-shopping-cart.js.map